/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BillingEventActionEnum } from './billingEventActionEnum';
import { BillingEventActionPayload } from './billingEventActionPayload';


export interface BillingEvent { 
    /**
     * Reporting Entity\'s UUID
     */
    entity_uuid: string;
    /**
     * Org ID of the entity
     */
    org_id: string;
    /**
     * CSP Service Type of the entity
     */
    service_type: string;
    /**
     * VCDS Service Type of the entity
     */
    vcds_service_type: string;
    action: BillingEventActionEnum;
    action_payload?: BillingEventActionPayload;
    /**
     * Timestamp in UTC when the event is applicable
     */
    action_timestamp: Date;
}
export namespace BillingEvent {
}


